__turbopack_context__.v({
  "admin-bg-danger": "Footer-module-scss-module__wcgw9G__admin-bg-danger",
  "admin-bg-info": "Footer-module-scss-module__wcgw9G__admin-bg-info",
  "admin-bg-primary": "Footer-module-scss-module__wcgw9G__admin-bg-primary",
  "admin-bg-secondary": "Footer-module-scss-module__wcgw9G__admin-bg-secondary",
  "admin-bg-success": "Footer-module-scss-module__wcgw9G__admin-bg-success",
  "admin-bg-warning": "Footer-module-scss-module__wcgw9G__admin-bg-warning",
  "admin-border": "Footer-module-scss-module__wcgw9G__admin-border",
  "admin-border-dark": "Footer-module-scss-module__wcgw9G__admin-border-dark",
  "admin-border-light": "Footer-module-scss-module__wcgw9G__admin-border-light",
  "admin-rounded": "Footer-module-scss-module__wcgw9G__admin-rounded",
  "admin-rounded-full": "Footer-module-scss-module__wcgw9G__admin-rounded-full",
  "admin-rounded-lg": "Footer-module-scss-module__wcgw9G__admin-rounded-lg",
  "admin-rounded-md": "Footer-module-scss-module__wcgw9G__admin-rounded-md",
  "admin-rounded-sm": "Footer-module-scss-module__wcgw9G__admin-rounded-sm",
  "admin-shadow-lg": "Footer-module-scss-module__wcgw9G__admin-shadow-lg",
  "admin-shadow-md": "Footer-module-scss-module__wcgw9G__admin-shadow-md",
  "admin-shadow-sm": "Footer-module-scss-module__wcgw9G__admin-shadow-sm",
  "admin-sr-only": "Footer-module-scss-module__wcgw9G__admin-sr-only",
  "admin-text-light": "Footer-module-scss-module__wcgw9G__admin-text-light",
  "admin-text-muted": "Footer-module-scss-module__wcgw9G__admin-text-muted",
  "admin-text-primary": "Footer-module-scss-module__wcgw9G__admin-text-primary",
  "admin-text-secondary": "Footer-module-scss-module__wcgw9G__admin-text-secondary",
  "footer": "Footer-module-scss-module__wcgw9G__footer",
  "footer--offline": "Footer-module-scss-module__wcgw9G__footer--offline",
  "footer__base": "Footer-module-scss-module__wcgw9G__footer__base",
  "footer__blackShape": "Footer-module-scss-module__wcgw9G__footer__blackShape",
  "footer__content": "Footer-module-scss-module__wcgw9G__footer__content",
  "footer__grid": "Footer-module-scss-module__wcgw9G__footer__grid",
  "footer__grid-column": "Footer-module-scss-module__wcgw9G__footer__grid-column",
  "footer__grid-item": "Footer-module-scss-module__wcgw9G__footer__grid-item",
  "footer__mask": "Footer-module-scss-module__wcgw9G__footer__mask",
  "footer__title": "Footer-module-scss-module__wcgw9G__footer__title",
  "footer__video": "Footer-module-scss-module__wcgw9G__footer__video",
});
